import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=423cc7c4&scoped=true"
import script from "@/controllers/componentHooks/typography/index.js?vue&type=script&lang=js&external"
export * from "@/controllers/componentHooks/typography/index.js?vue&type=script&lang=js&external"
import style0 from "./Typography.css?vue&type=style&index=0&id=423cc7c4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cc7c4",
  null
  
)

export default component.exports